module.exports = __webpack_public_path__ + "static/media/2022-10-17-01.09bc4b91.png";